import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ModeEditOutlineIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"mode_edit_outline"} ref={ref}/>
});

ModeEditOutlineIcon.displayName = "ModeEditOutlineIcon";
